import axios from 'axios';

function tenantFromJwt(token: string): string | null {
  try {
    const payload = token.split('.')[1];
    if (!payload) return null;
    const claims = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
    return claims.tenant_id || claims.tenant || null;
  } catch { return null; }
}

export function setupAxiosAuth(): void {
  axios.interceptors.request.use((config) => {
    try {
      const token = localStorage.getItem('access_token');
      if (token && !config.headers?.Authorization) {
        config.headers = config.headers ?? {};
        (config.headers as Record<string, string>)['Authorization'] = `Bearer ${token}`;
      }
      const tenant = localStorage.getItem('tenant_id') || (token ? tenantFromJwt(token) : null);
      if (tenant && !(config.headers as Record<string, string>)?.['X-Tenant-ID']) {
        config.headers = config.headers ?? {};
        (config.headers as Record<string, string>)['X-Tenant-ID'] = tenant;
      }
    } catch { /* SSR safety */ }
    return config;
  });
}
